import sdl from '@jds/react-generated-sdl/JDSDatepickerButton';
import type { JDSDatepickerButtonProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDatepickerButtonProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    state = 'default',
    ariaLabel = props.text?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { state, ariaLabel, ...rest },
    'JDSDatepickerButton',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DatepickerButton = withLogic(
  Component
) as React.FC<JDSDatepickerButtonProps> & { slotName?: string };

DatepickerButton.displayName = 'DatepickerButton';
DatepickerButton.slotName = 'jds_datepicker_button';

export { DatepickerButton, type JDSDatepickerButtonProps };
